export class ViewApplicationPeopleOfInterestRcConstants {
    // Controls
    static TRANSFEROR_FORM_CONTROL_NAME = "transferor";
    static TRANSFEREE_FORM_CONTROL_NAME = "transferee";
    static CONVEYANCER_FORM_CONTROL_NAME = "conveyancer";
    // Labels
    static TRANSFEROR_LABEL = "Transferor Details";
    static TRANSFEREE_LABEL = "Transferee Details";
    static CONVEYANCER_LABEL = "Conveyancer Details";
    static COPY_APPLICANT_TO_TRANSFEREE_LABEL = "Copy Applicant To Transferee";
}
